import React from 'react';
import './AccordionCheckbox.css';
const AccordionCheckbox = ({ children = null, cls = "", open = false, handlerCheckboxSelected = null, label, errorMessage = "", errorClass = "error", showInFalse = false }) => {
    if(handlerCheckboxSelected === null){
        console.error("Debe asignar un manejador para el checkbox seleccionado (handlerCheckboxSelected)");
        return false;
    }
    
    return (
        <div className={`accordionCheckboxContainer ${cls}`}>
            <div className={`topCheckbox`}>
                {/* <input type="checkbox" name={label} checked={open ? "checked" : ""} onChange={(e)=>{handlerCheckboxSelected(e.currentTarget.checked)}}/> */}
                <div className={`accordionCheckbox ${open ? "checked" : ""}`} name={label} onClick={(e)=>{
                    handlerCheckboxSelected(!e.currentTarget.classList.contains('checked'))
                    }}>
                        <i className="fas fa-check"></i>
                </div>
                <label onClick={(e)=>{
                    handlerCheckboxSelected(!e.currentTarget.parentNode.querySelector('.accordionCheckbox').classList.contains('checked'))
                    }}>{label}</label>
            </div>
            {
                children !== null ?
                <div className={`bodyContent ${!showInFalse ? (open ? "active" : "") : (!open ? "active" : "") }`}>
                    {children}
                </div>
                : <div className="none"></div>
            }
            
            <div className="footerContent">
                {
                    errorMessage !== "" ? <span className={errorClass}>{errorMessage}</span> : ""
                }
            </div>
        </div>
    );
}
export default AccordionCheckbox;